import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
} from "@material-ui/core";
import TituloTheme from "./Titulo.styles";

const Titulo = (props) => {
  const classes = TituloTheme();

  const tableTitle = props.title || 'Painel de Monitoramento';

  return props.pesquisa ? (
    <AppBar position="sticky">
      <Toolbar>
        <Container className={classes.container}>
          <Typography variant="h5">Painel de Monitoramento</Typography>
          <div className={classes.grow}></div>
        </Container>
      </Toolbar>
    </AppBar>
  ) : (
    <AppBar position="relative" className={classes.appBar}>
      <Toolbar>
        <Typography variant="h5">{tableTitle}</Typography>
        <div className={classes.grow}></div>
      </Toolbar>
    </AppBar>
  );
};

export default Titulo;
